import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const PasswordResetConfirm = () => {
    const { t } = useLanguage();
    
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 text-center">
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        {t('auth.passwordResetConfirm.title', 'Check Your Email')}
                    </h2>
                    <p className="mt-2 text-center text-sm text-gray-600">
                        {t('auth.passwordResetConfirm.desc', "We've sent a password reset link to your email address. Please check your inbox and follow the instructions.")}
                    </p>
                </div>
                
                <div className="mt-4">
                    <p className="text-sm text-gray-500">
                        {t('auth.passwordResetConfirm.notReceived', "Didn't receive the email? Check your spam folder or")}{' '}
                        <Link to="/forgot-password" className="text-blue-600 hover:text-blue-500">
                            {t('auth.passwordResetConfirm.tryAgain', 'try again')}
                        </Link>
                    </p>
                </div>

                <div className="mt-6">
                    <Link
                        to="/login"
                        className="text-blue-600 hover:text-blue-500"
                    >
                        {t('auth.passwordResetConfirm.backToLogin', 'Back to Login')}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PasswordResetConfirm;